import { css } from '@emotion/css'

export const PiAttachmentListClass = () => css`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`
